import { EXTENDED_COLUMN_MAP, SHAMIR_SHARED_ROW_DEFAULTS } from '../../consts';
import { CatalogOutputRow, ShamirSTInputRow } from '../../types';
import { formatPrice, parseBooleanToBinary } from '../../utils';
import {
    formatShamirSTDecimal,
    getShamirSTCoating,
    getShamirSTConstruction,
    getShamirSTFrameType,
    getShamirSTIndex,
    getShamirSTIsColored,
    getShamirSTIsPhotochromic,
    getShamirSTPhotochromicColor,
    sumShamirSTDecimals,
} from './shamir-st-field-parsers.util';

export const getShamirSTParsedRowData = (row: ShamirSTInputRow): CatalogOutputRow => {
    const isPhotochromic = getShamirSTIsPhotochromic(row.name);
    const sphMin = formatShamirSTDecimal(row.sphMin);
    const sphMax = formatShamirSTDecimal(row.sphMax);
    const cylMin = formatShamirSTDecimal(row.cylMin);
    const cylMax = formatShamirSTDecimal(row.cylMax);

    return {
        ...SHAMIR_SHARED_ROW_DEFAULTS,
        A: row.name,
        B: row.catalogNumber,
        F: formatPrice(row.buyPrice),
        G: formatPrice(row.sellPrice),
        I: parseBooleanToBinary(isPhotochromic),
        K: isPhotochromic ? getShamirSTPhotochromicColor(row.name) : 0,
        L: parseBooleanToBinary(false),
        M: 0,
        O: 'Organiczne',
        P: getShamirSTConstruction(row.name),
        Q: 'Jednoogniskowe',
        R: parseBooleanToBinary(getShamirSTIsColored(row.name)),
        W: getShamirSTCoating(row.name),
        X: getShamirSTFrameType(row.name),
        Y: getShamirSTIndex(row.name),
        AB: 0,
        AC: 0,
        AD: 0,
        AE: cylMin,
        AF: sphMin,
        AG: sphMax,
        AH: cylMax,
        AI: sphMin,
        AJ: sphMax,
        AK: sumShamirSTDecimals(row.cylMin, row.sphMin),
        AL: sumShamirSTDecimals(row.cylMax, row.sphMax),
    };
};

export const getShamirSTParsedRowDataAsRecord = (row: ShamirSTInputRow) => {
    const valuesByKey = getShamirSTParsedRowData(row);

    return Object.keys(valuesByKey).reduce((acc, curr) => {
        const currentKey = curr as keyof typeof EXTENDED_COLUMN_MAP;

        acc[EXTENDED_COLUMN_MAP[currentKey]] = valuesByKey[currentKey];

        return acc;
    }, {} as Record<string, unknown>);
};
